import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Spin,
  Form,
  Card,
  Select,
  DatePicker,
  InputNumber,
  Dropdown,
} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";

import MainLayout from "../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../components/layouts/enhancement/TopContent";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import Settings01 from "@untitled-ui/icons-react/build/esm/Settings01";
import cnt from "../../../services/definedConstant";
import { rightAction } from "../../../redux/actions";
import {
  labelConfig,
  staticConfig,
  apiConfig,
} from "../treasuryContractBooking.config";
import { BOM } from "../../../services/definedMethod";

const ViewTrade = (props) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    if (id) fetchTradeDetail(id);
  }, [id]);

  const fetchTradeDetail = async (tradeId) => {
    try {
      setIsLoading(true);
      // const res = await BOM.SendReq(apiConfig.getTradeById, { id: tradeId });
      const data = {
        productId: 1,
        securityMasterId: 1,
        portfolioId: 1,
        counterpartyId: 1,
        tradeDate: "2026-02-22",
        settlementDate: "2026-02-24",
        maturityDate: "2026-05-25",
        faceValue: 50_000_000.0,
        tradePrice: 98.5,
        considerationAmount: 49_250_000.0,
      };
      form.setFieldsValue({
        ...data,
        tradeDate: dayjs(data.tradeDate),
        settlementDate: dayjs(data.settlementDate),
        maturityDate: dayjs(data.maturityDate),
      });
    } catch (error) {
      BOM.AlertMsg(
        cnt.DANGER,
        error?.message || "Failed to load trade details.",
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleAction = ({ key }) => {
    switch (key) {
      case "confirm_trade":
        // navigate(`/trade/${id}/confirm`);
        navigate(`/trade/confirm`);
        break;
      case "settle_trade":
        /* BOM.SendReq(apiConfig.settleTrade) */ break;
      case "cancel_trade":
        // navigate(`/trade/${id}/cancel`);
        navigate(`/trade/cancel`);
        break;
      case "convert_allotment":
        // navigate(`/trade/${id}/convert-allotment`);
        navigate(`/trade/convert-allotment`);
        break;
      default:
        break;
    }
  };

  const actionMenuItems = [
    { key: "confirm_trade", label: "Confirm Trade" },
    { key: "settle_trade", label: "Settle Trade" },
    { type: "divider" },
    {
      key: "cancel_trade",
      label: <span style={{ color: "#B42318" }}>Cancel Trade</span>,
    },
    { type: "divider" },
    { key: "convert_allotment", label: "Convert Allotment to Trade" },
  ];

  const ds = { height: 44, background: "#F9FAFB", cursor: "not-allowed" };

  return (
    <MainLayout pageItems={staticConfig.viewTrade}>
      {/* <TopContent pageTitle={labelConfig.trade} /> */}

      <Spin spinning={isLoading} size="large">
        <div style={{ padding: "24px" }}>
          <Card
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
          >
            <Row
              justify="space-between"
              align="middle"
              style={{ marginBottom: 24 }}
            >
              <Col>
                <h3 style={{ margin: 0, fontWeight: 600 }}>Trade Details</h3>
              </Col>
              <Col>
                <Dropdown
                  menu={{ items: actionMenuItems, onClick: handleAction }}
                  trigger={["click"]}
                  placement="bottomRight"
                >
                  <button
                    type="button"
                    style={{
                      height: 44,
                      padding: "0 20px",
                      borderRadius: 8,
                      border: "1px solid #D0D5DD",
                      background: "#fff",
                      color: "#344054",
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <Settings01 width={16} height={16} color="#344054" />
                    Actions
                    <ChevronDown width={16} height={16} color="#667085" />
                  </button>
                </Dropdown>
              </Col>
            </Row>

            <Form layout="vertical" form={form}>
              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Product{" "}
                        <Tooltip title="The product this trade is booked against.">
                          <InfoCircleOutlined
                            style={{ marginLeft: 4, color: "#667085" }}
                          />
                        </Tooltip>
                      </span>
                    }
                    name="productId"
                  >
                    <Select
                      style={ds}
                      suffixIcon={<ChevronDown color="#667085" />}
                      placeholder="—"
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Security Master{" "}
                        <Tooltip title="The underlying security instrument for this trade.">
                          <InfoCircleOutlined
                            style={{ marginLeft: 4, color: "#667085" }}
                          />
                        </Tooltip>
                      </span>
                    }
                    name="securityMasterId"
                  >
                    <Select
                      style={ds}
                      suffixIcon={<ChevronDown color="#667085" />}
                      placeholder="—"
                      disabled
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Portfolio{" "}
                        <Tooltip title="The portfolio this trade is assigned to.">
                          <InfoCircleOutlined
                            style={{ marginLeft: 4, color: "#667085" }}
                          />
                        </Tooltip>
                      </span>
                    }
                    name="portfolioId"
                  >
                    <Select
                      style={ds}
                      suffixIcon={<ChevronDown color="#667085" />}
                      placeholder="—"
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Counterparty{" "}
                        <Tooltip title="The counterparty on the other side of this trade.">
                          <InfoCircleOutlined
                            style={{ marginLeft: 4, color: "#667085" }}
                          />
                        </Tooltip>
                      </span>
                    }
                    name="counterpartyId"
                  >
                    <Select
                      style={ds}
                      suffixIcon={<ChevronDown color="#667085" />}
                      placeholder="—"
                      disabled
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Trade Date{" "}
                        <Tooltip title="The date the trade was executed.">
                          <InfoCircleOutlined
                            style={{ marginLeft: 4, color: "#667085" }}
                          />
                        </Tooltip>
                      </span>
                    }
                    name="tradeDate"
                  >
                    <DatePicker
                      style={{
                        width: "100%",
                        height: 44,
                        background: "#F9FAFB",
                        cursor: "not-allowed",
                      }}
                      format="YYYY-MM-DD"
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Settlement Date{" "}
                        <Tooltip title="The date the trade settles.">
                          <InfoCircleOutlined
                            style={{ marginLeft: 4, color: "#667085" }}
                          />
                        </Tooltip>
                      </span>
                    }
                    name="settlementDate"
                  >
                    <DatePicker
                      style={{
                        width: "100%",
                        height: 44,
                        background: "#F9FAFB",
                        cursor: "not-allowed",
                      }}
                      format="YYYY-MM-DD"
                      disabled
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Maturity Date{" "}
                        <Tooltip title="The date the instrument matures.">
                          <InfoCircleOutlined
                            style={{ marginLeft: 4, color: "#667085" }}
                          />
                        </Tooltip>
                      </span>
                    }
                    name="maturityDate"
                  >
                    <DatePicker
                      style={{
                        width: "100%",
                        height: 44,
                        background: "#F9FAFB",
                        cursor: "not-allowed",
                      }}
                      format="YYYY-MM-DD"
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Face Value{" "}
                        <Tooltip title="The nominal / par value of the trade.">
                          <InfoCircleOutlined
                            style={{ marginLeft: 4, color: "#667085" }}
                          />
                        </Tooltip>
                      </span>
                    }
                    name="faceValue"
                  >
                    <InputNumber
                      style={{ width: "100%", ...ds }}
                      formatter={(v) =>
                        v ? `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ""
                      }
                      parser={(v) => v?.replace(/,/g, "")}
                      precision={2}
                      disabled
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Trade Price{" "}
                        <Tooltip title="The price per 100 face value.">
                          <InfoCircleOutlined
                            style={{ marginLeft: 4, color: "#667085" }}
                          />
                        </Tooltip>
                      </span>
                    }
                    name="tradePrice"
                  >
                    <InputNumber
                      style={{ width: "100%", ...ds }}
                      precision={2}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Consideration Amount{" "}
                        <Tooltip title="The actual cash amount exchanged for this trade.">
                          <InfoCircleOutlined
                            style={{ marginLeft: 4, color: "#667085" }}
                          />
                        </Tooltip>
                      </span>
                    }
                    name="considerationAmount"
                  >
                    <InputNumber
                      style={{ width: "100%", ...ds }}
                      formatter={(v) =>
                        v ? `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ""
                      }
                      parser={(v) => v?.replace(/,/g, "")}
                      precision={2}
                      disabled
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div
                style={{ borderTop: "1px solid #EAECF0", margin: "8px 0 20px" }}
              />

              <Row justify="end">
                <Col>
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    style={{
                      height: 44,
                      padding: "0 24px",
                      borderRadius: 8,
                      border: "1px solid #D0D5DD",
                      background: "#fff",
                      color: "#344054",
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: "pointer",
                    }}
                  >
                    Back
                  </button>
                </Col>
              </Row>
            </Form>
          </Card>
        </div>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({ rightBtn: state.RightSideBtn });
export default connect(mapStateToProps, { rightAction })(ViewTrade);
